import React from 'react'
import Img from 'gatsby-image'
import ResponsiveMenu from 'react-responsive-navbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'

class Menu extends React.Component {

    expandMarkup = <div>
           <FontAwesomeIcon icon={faBars} /> 
        </div>

    collapseMarkup = <div>
           <FontAwesomeIcon icon={faTimes} /> 
        </div> 

    render() {
        return (
            <ResponsiveMenu
                menuOpenButton={this.expandMarkup}
                menuCloseButton={this.collapseMarkup}
                changeMenuOn="500px"
                largeMenuClassName="nav-large"
                smallMenuClassName="nav-small"
                menu={
                <ul>
                    <li>
                        <a href="/">Home</a>
                    </li>
                    <li>
                        <a href="/service-plans">Service Plans</a>
                    </li>
                </ul>
                }
            />
        )
    }
}

export default Menu




// WEBPACK FOOTER //
// ./src/components/Menu.js